// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__10MMe","header":"PatientBlock_header__U7815","label":"PatientBlock_label__h5o5X","option":"PatientBlock_option__MphaN"};